// extracted by mini-css-extract-plugin
export var avatarContainer = "_9l-0";
export var avatarTypingWave = "_9l-i";
export var gray = "_9l-f";
export var green = "_9l-c";
export var icon = "_9l-9";
export var image = "_9l-1";
export var lg = "_9l-6";
export var md = "_9l-5";
export var presenceDot = "_9l-b";
export var red = "_9l-d";
export var sm = "_9l-4";
export var status = "_9l-a";
export var typingDot = "_9l-h";
export var typingPill = "_9l-g";
export var xl = "_9l-7";
export var xs = "_9l-3";
export var xxl = "_9l-8";
export var xxs = "_9l-2";
export var yellow = "_9l-e";